import React from "react";
import { FaPlus } from "react-icons/fa";
import { SortEndHandler } from "react-sortable-hoc";
import { ExerciseWrapper } from "../ExerciseWrapper";
import { AddNewList, AddNewListText } from "../list-items/ListItemsExercisePart.styles";
import { IOrderItemsProps } from "./OrderItems.types";
import { SortableOrderItemList } from "./SortableOrderItems";

export const OrderItemsComponent: React.FC<IOrderItemsProps> = props => {
  const { addOrderItem, currentLocale, exercisePart, isEditing, partOperations, sortPartRequest } = props;

  const addItem = () => addOrderItem({ exercise: exercisePart });

  const sortItem: SortEndHandler = sort => {
    if (sort.oldIndex !== sort.newIndex) {
      sortPartRequest({
        from: sort.oldIndex,
        itemId: exercisePart.id,
        to: sort.newIndex,
      });
    }
  };

  return (
    <ExerciseWrapper
      currentLocale={currentLocale}
      edit={isEditing}
      exercisePart={exercisePart}
      partOperations={partOperations}
    >
      <SortableOrderItemList {...props} lockAxis="y" onSortEnd={sortItem} useDragHandle={true} />
      {isEditing && (
        <AddNewList onClick={addItem}>
          <FaPlus />
          <AddNewListText>Click to add another option.</AddNewListText>
        </AddNewList>
      )}
    </ExerciseWrapper>
  );
};
